import { useEvaluateFilterBranchUsingSnapshotDataLazyQuery } from '../../__generated__/chirp/com/hubspot/segment/rpc/SegmentEvaluationRpc.hooks';
import { useBuildSnapshotForInputMutation } from '../../__generated__/chirp/com/hubspot/segment/rpc/SegmentSnapshotRpc.hooks';
import { useEffect, useState } from 'react';
export const useEvaluateFiltersForAll = (filterBranch, objectTypeId, buildFreshSnapshot = false, evaluateSnapshot = false) => {
  // primaryObjectType/primaryRecordType should be a string of the object type the filters are for, e.g., '0-1'
  // filterBranch should be FQF that we'd send to the ILS backend for evaluation, but as a string
  const filterBranchString = filterBranch ? JSON.stringify(filterBranch) : undefined;
  const [buildSnapshot] = useBuildSnapshotForInputMutation();
  const [snapshotBuilt, setSnapshotBuilt] = useState(false);
  const [snapshotError, setSnapshotError] = useState(undefined);
  const [executeEvaluation, evaluationQueryResult] = useEvaluateFilterBranchUsingSnapshotDataLazyQuery();
  useEffect(() => {
    if (filterBranchString && buildFreshSnapshot) {
      setSnapshotBuilt(false);
      setSnapshotError(undefined);
      buildSnapshot({
        variables: {
          primaryRecordType: objectTypeId,
          filterBranch: filterBranchString
        }
      }).then(() => {
        setSnapshotBuilt(true);
      }).catch(err => {
        setSnapshotError(err);
      });
    } else {
      // If we're not building a fresh snapshot, we can proceed immediately
      setSnapshotBuilt(true);
    }
  }, [buildFreshSnapshot, filterBranchString, objectTypeId, buildSnapshot]);
  const canEvaluate = filterBranchString && evaluateSnapshot;
  const isSnapshotReady = !buildFreshSnapshot || snapshotBuilt;
  const shouldEvaluate = canEvaluate && isSnapshotReady && !snapshotError;
  useEffect(() => {
    if (shouldEvaluate) {
      executeEvaluation({
        variables: {
          primaryObjectType: objectTypeId,
          filterBranch: filterBranchString
        }
      });
    }
  }, [shouldEvaluate, executeEvaluation, objectTypeId, filterBranchString]);
  if (snapshotError) {
    return {
      loading: false,
      error: snapshotError,
      data: undefined
    };
  }
  return evaluationQueryResult;
};